// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1ybjp","log":"ModalInventoryLogs_log__m2BMY","date":"ModalInventoryLogs_date__2J8Xy","userName":"ModalInventoryLogs_userName__zQWBD"};